import { createSelector } from '@ngrx/store';
import { appSettingsState } from '../root';

export const getRedemptionRate = createSelector(appSettingsState, (appSettings) => appSettings.apiSettings?.data?.RedemptionRate);
